var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "l-bg-white row jobs-edit" }, [
        _c(
          "div",
          { staticClass: "col-12 col-lg-9 col-xl-9" },
          [
            !_vm.job.ref_id
              ? [_c("content-loader")]
              : [
                  _c(
                    "div",
                    { staticClass: "row d-flex bg-grey py-2 header-edit" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-5 col-xl-10 col-md-10 col-lg-10" },
                        [
                          _c(
                            "div",
                            { staticClass: "row align-items-center" },
                            [
                              _vm.job.status_id !== ""
                                ? _c("JobStatus", {
                                    attrs: {
                                      "lead-source": _vm.leadSource
                                        ? _vm.leadSource
                                        : {},
                                      "ref-id": _vm.job.ref_id,
                                      status: _vm.job.status,
                                      source: _vm.job.source,
                                      "is-flat-rate": _vm.isFlatRate
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("JobMoveInfo", { attrs: { job: _vm.job } })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("JobInfo", {
                        attrs: {
                          "show-moving-contract-button":
                            _vm.showMovingContractButton,
                          "show-email-confirmation-modal":
                            _vm.showEmailConfirmationModal,
                          "has-access": _vm.userHasAccessToCarrier,
                          changes: _vm.changes,
                          job: _vm.job
                        },
                        on: {
                          createClaim: function($event) {
                            _vm.newClaim = true
                          },
                          showCarrierReassignModal: function($event) {
                            _vm.showCarrierReassignModal = true
                            _vm.getCarriers()
                          },
                          showModalCancelJob: function($event) {
                            _vm.showModalCancelJob = true
                          },
                          showModalAcceptJob: function($event) {
                            _vm.showModalAcceptJob = true
                          },
                          showModalIsSmallJob: function($event) {
                            _vm.showModalIsSmallJob = true
                          },
                          showModalRejectJob: function($event) {
                            _vm.showModalRejectJob = true
                          },
                          changeToInProgress: function($event) {
                            _vm.changeStatus(_vm.job.id, 40)
                          },
                          changeToOnHold: function($event) {
                            _vm.changeStatus(_vm.job.id, 21)
                          },
                          showRevertToAccepted: function($event) {
                            _vm.showAreYouSureRevertModal = true
                          },
                          showRevertToTotalTime: function($event) {
                            _vm.showAreYouSureRevertTotalTimeModal = true
                          },
                          showSendEpayLink: function($event) {
                            _vm.showSendEpayLinkModal = true
                          },
                          returnToPending: function($event) {
                            _vm.changeStatus(_vm.job.id, 2)
                          },
                          reassignUserModal: function($event) {
                            _vm.reassignUserModal()
                          },
                          getJob: _vm.getJob,
                          movingContractSent: _vm.movingContractSent,
                          toggleEmailConfirmationModal:
                            _vm.toggleEmailConfirmationModal
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.job.rejection_status_log &&
                  _vm.job.rejection_status_log.note &&
                  _vm.job.status_id === 31
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12 mt-3" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ml-4 d-flex align-items-center alert alert-rejection border-0"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-rejected-job mr-2"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "acknowledge-msg" }, [
                                _c("strong", [_vm._v("Rejection reason:")]),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.job.rejection_status_log.note) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("JobDetails", { attrs: { job: _vm.job } }),
                  _vm._v(" "),
                  _vm.job.customer
                    ? _c("JobCustomerInfo", {
                        attrs: {
                          job: _vm.job,
                          "user-id": _vm.user.id,
                          "has-access": _vm.userHasAccessToCarrier,
                          "customer-note": _vm.customerNote
                        },
                        on: {
                          review: function($event) {
                            _vm.companyReviewModal = !_vm.companyReviewModal
                          },
                          showCustomerModal: function($event) {
                            _vm.showCustomerModal = !_vm.showCustomerModal
                          },
                          saveCustomerNote: function(callback) {
                            return _vm.saveCustomerNote(callback)
                          }
                        }
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "p-3 mx-5 mb-3",
                          staticStyle: { "background-color": "#f8d7d9" }
                        },
                        [
                          _c("h6", [
                            _vm._v("\n            Deleted "),
                            _c("br"),
                            _vm._v("\n            Customer\n          ")
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _c("HeavyItemsDisclaimer", {
                    attrs: {
                      "company-heavy-items-fee":
                        _vm.job.company.heavy_items_fee,
                      editable: _vm.isActive,
                      "has-heavy-items": _vm.job.has_heavy_items,
                      "job-id": _vm.job.id,
                      "model-heavy-items-fee": _vm.job.heavy_items_fee
                    },
                    on: { getJob: _vm.getJob }
                  }),
                  _vm._v(" "),
                  _vm.$_can("tags.show")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "px-5 d-flex align-items-center justify-content-start flex-wrap mb-3"
                        },
                        _vm._l(_vm.job.company.tags, function(tag) {
                          return _c("tag-color", {
                            key: tag.id,
                            attrs: {
                              color: tag.color.name,
                              name: tag.name,
                              "input-class": "mr-3"
                            }
                          })
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasClaim
                    ? _c(
                        "div",
                        { staticClass: "py-3" },
                        [
                          _c("JobClaimBanner", {
                            attrs: { claim: _vm.job.claim }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.job.ratings && _vm.job.ratings.length
                    ? _c(
                        "div",
                        { staticClass: "py-3" },
                        [
                          _c("JobRating", {
                            attrs: { ratings: _vm.job.ratings },
                            on: {
                              getJob: function($event) {
                                _vm.getJob()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("JobRates", {
                    attrs: {
                      job: _vm.job,
                      config: _vm.config,
                      "edited-field": _vm.editedField,
                      "editable-fields": _vm.editableFields,
                      "arrival-windows": _vm.arrival_windows,
                      "move-sizes": _vm.move_sizes,
                      "number-of-movers": _vm.numberOfMovers,
                      "is-small-job": _vm.isSmallJob,
                      "has-access": _vm.userHasAccessToCarrier
                    },
                    on: {
                      editedField: function($event) {
                        _vm.editedField = true
                      },
                      editableFields: function($event) {
                        _vm.editableFields = true
                      },
                      getJob: _vm.getJob,
                      save: _vm.save
                    }
                  }),
                  _vm._v(" "),
                  _c("JobsTabs", {
                    attrs: { "job-tab-step": _vm.jobTabStep, plans: _vm.plans },
                    on: { jobTabStep: _vm.setJobTabStep }
                  }),
                  _vm._v(" "),
                  _c("JobsTabsContent", {
                    attrs: {
                      job: _vm.job,
                      "job-loading": _vm.jobLoading,
                      "job-tab-step": _vm.jobTabStep,
                      "edited-field": _vm.editedField,
                      "loading-discard-button": _vm.loadingDiscardButton,
                      "button-disabled": _vm.buttonDisabled,
                      "has-access": _vm.userHasAccessToCarrier,
                      "deleted-locations": _vm.deletedLocations
                    },
                    on: {
                      getJob: _vm.getJob,
                      editedField: function($event) {
                        _vm.editedField = true
                      },
                      loadingDiscardButton: function($event) {
                        _vm.loadingDiscardButton = true
                      },
                      buttonDisabled: function($event) {
                        _vm.buttonDisabled = true
                      },
                      sendAutomaticMessages: _vm.sendAutomaticMessagesMethod,
                      openAssignedMoversModal: _vm.openAssignedMoversModal,
                      openAssignedTrucksModal: _vm.openAssignedTrucksModal,
                      save: _vm.save,
                      discardJob: _vm.discardJob,
                      jobTabStep: _vm.setJobTabStep
                    }
                  })
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-lg-3 col-xl-3 complete-job-sidebar border-left pl-3 pr-5"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 nav nav-tabs nav-fill p-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-6 nav-item nav-link pointer",
                    class: [_vm.rightSidebarTab === "notes" ? "active" : ""],
                    on: {
                      click: function($event) {
                        _vm.rightSidebarTab = "notes"
                      }
                    }
                  },
                  [_vm._v("\n            Comments\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-6 nav-item nav-link pointer",
                    class: [
                      _vm.rightSidebarTab === "priceBreakdown" ? "active" : ""
                    ],
                    on: {
                      click: function($event) {
                        _vm.rightSidebarTab = "priceBreakdown"
                      }
                    }
                  },
                  [_vm._v("\n            Billing\n          ")]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.rightSidebarTab === "notes"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "row notes-box pt-3" },
                    [
                      _vm._l(_vm.job.notes, function(note) {
                        return _c(
                          "div",
                          {
                            key: note.id,
                            staticClass: "col-12 single-note pb-4"
                          },
                          [
                            typeof note.note === "string" &&
                            note.note.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "border rounded m-0 p-2" },
                                  [
                                    note.user.first_name
                                      ? _c(
                                          "strong",
                                          { staticClass: "d-block" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(note.user.first_name) +
                                                " " +
                                                _vm._s(note.user.last_name) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "strong",
                                          { staticClass: "d-block" },
                                          [_vm._v("customer")]
                                        ),
                                    _vm._v(" "),
                                    _c("p", [_vm._v(_vm._s(note.note))]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "small" }, [
                                      _vm._v(_vm._s(note.date))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.cancellationNote &&
                      _vm.job.status &&
                      _vm.job.status.name === "Canceled"
                        ? _c("div", { staticClass: "col-12 pb-4" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded m-0 p-2  single-note-cancelled"
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _vm.cancellationNote.cluster_user
                                  ? _c("strong", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.cancellationNote.cluster_user
                                              .first_name
                                          ) +
                                          "\n                " +
                                          _vm._s(
                                            _vm.cancellationNote.cluster_user
                                              .last_name
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  : _c("strong", [
                                      _vm._v(
                                        "\n                Customer\n              "
                                      )
                                    ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.cancellationNote.note))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "small" }, [
                                  _vm._v(
                                    _vm._s(_vm.cancellationNote.created_at)
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "row pt-2 px-2 mb-2 mx-0 fixed-bottom border-top position-absolute notes-field bg-white"
                    },
                    [
                      _c("div", { staticClass: "col-10 px-0" }, [
                        _vm.editNote
                          ? _c(
                              "div",
                              { staticClass: "border w-100 text-field" },
                              [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "auto-resize",
                                      rawName: "v-auto-resize"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.job.note,
                                      expression: "job.note"
                                    }
                                  ],
                                  domProps: { value: _vm.job.note },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.job,
                                        "note",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "border w-100 text-field" },
                              [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "auto-resize",
                                      rawName: "v-auto-resize"
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      _vm.editNote = true
                                    }
                                  }
                                })
                              ]
                            )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2 pointer px-0" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary pt-2",
                            attrs: { disabled: _vm.editNote === false },
                            on: { click: _vm.saveNote }
                          },
                          [_c("span", { staticClass: "mod-icon-note" })]
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.rightSidebarTab === "priceBreakdown"
              ? _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _c("div", { staticClass: "row mt-4" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Total job time")]),
                            _vm._v(" "),
                            _vm.configTimepicker
                              ? _c("input-time", {
                                  attrs: {
                                    "minute-interval":
                                      _vm.configTimepicker.minuteInterval
                                  },
                                  on: { close: _vm.saveJobTime },
                                  model: {
                                    value: _vm.job.job_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "job_time", $$v)
                                    },
                                    expression: "job.job_time"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("h5", [_vm._v("Price")]),
                        _vm._v(" "),
                        _vm.isFlatRate
                          ? _c("span", [
                              _vm._v(" $ " + _vm._s(_vm.job.price) + " ")
                            ])
                          : _c("span", [
                              _vm._v(
                                " $ " + _vm._s(_vm.job.price_per_hour) + " "
                              )
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.job.company.double_drive
                      ? _c("div", { staticClass: "row mt-4" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c(
                              "div",
                              { staticClass: "select-wrap" },
                              [
                                _c("label", [_vm._v("DDT")]),
                                _vm._v(" "),
                                _vm.ddTimeConfig
                                  ? _c("input-time", {
                                      attrs: {
                                        "minute-interval":
                                          _vm.ddTimeConfig.minuteIncrement
                                      },
                                      on: { close: _vm.saveDdTime },
                                      model: {
                                        value: _vm.job.double_drive_time,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "double_drive_time",
                                            $$v
                                          )
                                        },
                                        expression: "job.double_drive_time"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job && _vm.job.total_hours
                      ? _c("div", { staticClass: "row mt-4 mb-2" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-5 p-3 bg-grey flex justify-content-end"
                            },
                            [
                              _c("h4", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.job.total_hours))
                                ])
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job && _vm.job.total_time
                      ? [
                          _c("div", { staticClass: "row mb-2" }, [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-5 text-right" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.job.total_time) +
                                  "\n            "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.job.double_drive_added
                            ? _c("div", { staticClass: "row mb-2" }, [
                                _vm._m(3),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-5 text-right" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.job.double_drive_time) +
                                      "\n            "
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-5 text-right" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.job.breaks) +
                                  "\n            "
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    !_vm.isFlatRate
                      ? _c("div", { staticClass: "row mb-2 base-price" }, [
                          _c("div", { staticClass: "col-7" }, [
                            _c("p", [
                              _vm._v(
                                "\n              Base price\n              "
                              ),
                              _vm.job.job_time < _vm.job.minimum_hours &&
                              _vm.jobStatus
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "btn-status btn-booked px-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                (min hours charged)"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-5 text-right" }, [
                            _c("p", [_vm._v("$ " + _vm._s(_vm.job.base_price))])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-4 mb-2" }, [
                      _c("div", { staticClass: "col-7" }, [
                        _c(
                          "h4",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.additionalExpensesToggleAddition = !_vm.additionalExpensesToggleAddition
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa text-secondary",
                              class: _vm.additionalExpensesToggleAddition
                                ? "fa fa-caret-down"
                                : "fa fa-caret-right",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c("strong", { staticClass: "pl-1" }, [
                              _vm._v(
                                "\n                Additional expenses\n              "
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-5 text-right" }, [
                        _c("strong", [
                          _vm._v("$ " + _vm._s(_vm.job.total_expenses))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.additionalExpensesToggleAddition
                      ? [
                          _vm.expenses
                            ? _vm._l(_vm.expenses, function(expense, index) {
                                return _c(
                                  "div",
                                  { key: expense.id, staticClass: "row" },
                                  [
                                    _vm.editableExpenseAddition[index]
                                      ? [
                                          expense.type_id === 1
                                            ? _c(
                                                "div",
                                                { staticClass: "col-7 pr-1" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "border rounded amount-wrap-small"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: expense.name,
                                                            expression:
                                                              "expense.name"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control p-1",
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            "Expense name",
                                                          disabled: !_vm
                                                            .editableExpenseAddition[
                                                            index
                                                          ]
                                                        },
                                                        domProps: {
                                                          value: expense.name
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              expense,
                                                              "name",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn input-group-btn edit-transaction-remove",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.editExpenseAddition(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-remove"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          expense.type_id !== 1
                                            ? _c(
                                                "div",
                                                { staticClass: "col-7 pr-1" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "border rounded amount-wrap-small"
                                                    },
                                                    [
                                                      _c("simple-select", {
                                                        staticClass:
                                                          "form-control p-1 small-simple-select",
                                                        attrs: {
                                                          placeholder:
                                                            "Tip type",
                                                          options: _vm.tipType.filter(
                                                            function(type) {
                                                              return (
                                                                type.id !== 1
                                                              )
                                                            }
                                                          ),
                                                          "hide-select": true,
                                                          disabled: !_vm
                                                            .editableExpenseAddition[
                                                            index
                                                          ]
                                                        },
                                                        model: {
                                                          value:
                                                            expense.type_id,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              expense,
                                                              "type_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "expense.type_id"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn input-group-btn edit-transaction-remove close-tips",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.editExpenseAddition(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-remove"
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-3 px-1" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "border rounded amount-wrap-small amount-field"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "dollar" },
                                                    [_vm._v("$")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: expense.amount,
                                                        expression:
                                                          "expense.amount"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: "Amount",
                                                      disabled: !_vm
                                                        .editableExpenseAddition[
                                                        index
                                                      ]
                                                    },
                                                    domProps: {
                                                      value: expense.amount
                                                    },
                                                    on: {
                                                      keydown: function(
                                                        $event
                                                      ) {
                                                        _vm.clearError($event)
                                                      },
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          expense,
                                                          "amount",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("error-field", {
                                                attrs: {
                                                  errors: _vm.errors,
                                                  field: "amount"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-1 px-1" },
                                            [
                                              _vm.$_can("job-expenses.update")
                                                ? [
                                                    _vm.editableExpenseAddition[
                                                      index
                                                    ]
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-save",
                                                            attrs: {
                                                              type: "button"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.saveEditedExpense(
                                                                  index,
                                                                  expense
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "mod-icon-save"
                                                            })
                                                          ]
                                                        )
                                                      : _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-edit",
                                                            attrs: {
                                                              type: "button"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.editExpenseAddition(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "mod-icon-expense-edit"
                                                            })
                                                          ]
                                                        )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      : [
                                          _c("div", { staticClass: "col-5" }, [
                                            _c("h5", [
                                              _vm._v(
                                                _vm._s(expense && expense.name)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-5 text-right" },
                                            [
                                              _vm._v(
                                                "$ " + _vm._s(expense.amount)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.jobIsEditable &&
                                          expense.is_editable === 1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 text-right pointer"
                                                },
                                                [
                                                  _vm._m(6, true),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-menu",
                                                      attrs: {
                                                        "aria-labelledby":
                                                          "dropdownMenuButtonEditExpenseAddition"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item p-1 small",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.editExpenseAddition(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Edit"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item p-1 small",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.removeExpense(
                                                                index,
                                                                expense.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Delete"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                  ],
                                  2
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$_can("job-expenses.store") &&
                          _vm.addingNewAdditionalExpense === true
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-7 pr-1" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "border rounded amount-wrap-small"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.newExpense.name,
                                            expression: "newExpense.name"
                                          }
                                        ],
                                        staticClass: "form-control p-1",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Expense name"
                                        },
                                        domProps: {
                                          value: _vm.newExpense.name
                                        },
                                        on: {
                                          keydown: function($event) {
                                            _vm.clearError($event)
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.newExpense,
                                              "name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn input-group-btn edit-transaction-remove",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              _vm.addingNewAdditionalExpense = false
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-remove"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-3 px-1" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border rounded amount-wrap-small"
                                      },
                                      [
                                        _c("span", { staticClass: "dollar" }, [
                                          _vm._v("$")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.newExpense.amount,
                                              expression: "newExpense.amount"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Amount"
                                          },
                                          domProps: {
                                            value: _vm.newExpense.amount
                                          },
                                          on: {
                                            keydown: function($event) {
                                              _vm.clearError($event)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.newExpense,
                                                "amount",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("error-field", {
                                      attrs: {
                                        errors: _vm.errors,
                                        field: "amount"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-1 pt-1" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-save",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.saveExpense(1, false)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-save"
                                      })
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$_can("jobs.tips.store") &&
                          _vm.addingNewMoverTips === true
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-7 pr-1" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "border rounded amount-wrap-small position-relative"
                                    },
                                    [
                                      _c("simple-select", {
                                        staticClass:
                                          "form-control p-1 small-simple-select",
                                        attrs: {
                                          placeholder: "Tip type",
                                          options: _vm.tipType.filter(function(
                                            type
                                          ) {
                                            return type.id !== 1
                                          }),
                                          "hide-select": true
                                        },
                                        model: {
                                          value: _vm.newExpense.type_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.newExpense,
                                              "type_id",
                                              $$v
                                            )
                                          },
                                          expression: "newExpense.type_id"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn input-group-btn edit-transaction-remove close-tips",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.addingNewMoverTips = false
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-remove" })]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-3 px-1" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border rounded amount-wrap-small amount-field"
                                      },
                                      [
                                        _c("span", { staticClass: "dollar" }, [
                                          _vm._v("$")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.newExpense.amount,
                                              expression: "newExpense.amount"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Amount"
                                          },
                                          domProps: {
                                            value: _vm.newExpense.amount
                                          },
                                          on: {
                                            keydown: function($event) {
                                              _vm.clearError($event)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.newExpense,
                                                "amount",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("error-field", {
                                      attrs: {
                                        errors: _vm.errors,
                                        field: "amount"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-1 pt-1" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-save",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          _vm.saveExpense(1, true)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-save"
                                      })
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.addingNewAdditionalExpense === false
                            ? _c("div", { staticClass: "row mt-2" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _vm.$_can("job-expenses.store") &&
                                  _vm.canEditJob
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "add-button pointer pull-right",
                                          class: {
                                            disabled:
                                              !_vm.userHasAccessToCarrier ||
                                              _vm.isFlatRate
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled:
                                              !_vm.userHasAccessToCarrier ||
                                              _vm.isFlatRate
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addingNewExpense("additional")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Add expenses\n                "
                                          ),
                                          _vm._m(7)
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.addingNewMoverTips === false
                            ? _c("div", { staticClass: "row mt-2" }, [
                                _c("div", { staticClass: "col-12 mt-3" }, [
                                  _vm.$_can("jobs.tips.store") && _vm.canAddTips
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "add-button pointer pull-right",
                                          class: {
                                            disabled:
                                              !_vm.userHasAccessToCarrier ||
                                              _vm.isFlatRate
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled:
                                              !_vm.userHasAccessToCarrier ||
                                              _vm.isFlatRate
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addingNewExpense("tips")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Add tips\n                "
                                          ),
                                          _vm._m(8)
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-4 mb-2" }, [
                      _c("div", { staticClass: "col-7" }, [
                        _c(
                          "h4",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.additionalExpensesToggleDiscount = !_vm.additionalExpensesToggleDiscount
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa text-secondary",
                              class: _vm.additionalExpensesToggleDiscount
                                ? "fa fa-caret-down"
                                : "fa fa-caret-right",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c("strong", { staticClass: "pl-1" }, [
                              _vm._v(
                                "\n                Discount\n              "
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-5 text-right" }, [
                        _c("strong", [
                          _vm._v("- $ " + _vm._s(_vm.job.total_discounts))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.additionalExpensesToggleDiscount
                      ? [
                          _vm.expenses
                            ? _vm._l(_vm.discounts, function(expense, index) {
                                return _c(
                                  "div",
                                  { key: expense.id, staticClass: "row" },
                                  [
                                    _vm.editableExpenseDiscount[index]
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "col-5 pr-1" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "border rounded amount-wrap-small"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: expense.name,
                                                        expression:
                                                          "expense.name"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control p-1",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "Discount name",
                                                      disabled: !_vm
                                                        .editableExpenseDiscount[
                                                        index
                                                      ]
                                                    },
                                                    domProps: {
                                                      value: expense.name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          expense,
                                                          "name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn input-group-btn edit-transaction-remove",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.editExpenseDiscount(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-remove"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-3 pr-1" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "border rounded"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: expense.amount,
                                                        expression:
                                                          "expense.amount"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control pl-1",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: "Amount",
                                                      disabled: !_vm
                                                        .editableExpenseDiscount[
                                                        index
                                                      ]
                                                    },
                                                    domProps: {
                                                      value: expense.amount
                                                    },
                                                    on: {
                                                      keydown: function(
                                                        $event
                                                      ) {
                                                        _vm.clearError($event)
                                                      },
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          expense,
                                                          "amount",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("error-field", {
                                                attrs: {
                                                  errors: _vm.errors,
                                                  field: "amount"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-4" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "border rounded amount-wrap-small"
                                                },
                                                [
                                                  _c("simple-select", {
                                                    staticClass:
                                                      "form-control p-1 small-simple-select",
                                                    attrs: {
                                                      placeholder:
                                                        "Discount type",
                                                      options:
                                                        _vm.discountUnitTypes,
                                                      "hide-select": true
                                                    },
                                                    model: {
                                                      value:
                                                        expense.discount_unit_type_id,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          expense,
                                                          "discount_unit_type_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "expense.discount_unit_type_id"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("error-field", {
                                                attrs: {
                                                  errors: _vm.errors,
                                                  field: "discount_unit_type_id"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-8 mt-1 pr-1 mb-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "border rounded amount-wrap-small"
                                                },
                                                [
                                                  _c("simple-select", {
                                                    staticClass:
                                                      "form-control p-1 small-simple-select",
                                                    attrs: {
                                                      placeholder:
                                                        "Discount type",
                                                      options:
                                                        _vm.discountTypes,
                                                      "hide-select": true,
                                                      disabled:
                                                        !_vm
                                                          .editableExpenseDiscount[
                                                          index
                                                        ] ||
                                                        !_vm.$_can(
                                                          "job-discounts.change-type"
                                                        )
                                                    },
                                                    model: {
                                                      value: expense.type_id,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          expense,
                                                          "type_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "expense.type_id"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 pt-2 d-flex justify-content-end"
                                            },
                                            [
                                              _vm.$_can("job-discounts.update")
                                                ? [
                                                    _vm.editableExpenseDiscount[
                                                      index
                                                    ]
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-save",
                                                            attrs: {
                                                              type: "button"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.saveEditedDiscount(
                                                                  index,
                                                                  expense.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "mod-icon-save"
                                                            })
                                                          ]
                                                        )
                                                      : _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-edit",
                                                            attrs: {
                                                              type: "button"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.editExpenseDiscount(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "mod-icon-expense-edit"
                                                            })
                                                          ]
                                                        )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      : [
                                          _c("div", { staticClass: "col-6" }, [
                                            _c("h5", [
                                              _vm._v(
                                                _vm._s(
                                                  expense && expense.name
                                                ) +
                                                  " (" +
                                                  _vm._s(expense.type.name) +
                                                  ")"
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-4 text-right" },
                                            [
                                              expense.discount_unit_type_id ===
                                              1
                                                ? [
                                                    _vm._v(
                                                      "\n                    - $ " +
                                                        _vm._s(expense.amount) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                : expense.discount_unit_type_id ===
                                                  2
                                                  ? [
                                                      _vm._v(
                                                        "\n                    - $ " +
                                                          _vm._s(
                                                            expense.calculated_amount
                                                          ) +
                                                          " (" +
                                                          _vm._s(
                                                            expense.amount
                                                          ) +
                                                          "%)\n                  "
                                                      )
                                                    ]
                                                  : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          !expense.is_editable &&
                                          !expense.is_likes_discount &&
                                          !expense.from_subscription &&
                                          _vm.$_can("jobs.discount.cash.remove")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 text-right pointer"
                                                },
                                                [
                                                  _vm._m(9, true),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-menu",
                                                      attrs: {
                                                        "aria-labelledby":
                                                          "dropdownMenuButtonEditExpenseDiscount1"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item p-1 small",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.showClearCashDiscountModal = true
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Delete"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.jobIsEditable &&
                                          expense.is_editable === 1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 text-right pointer"
                                                },
                                                [
                                                  _vm._m(10, true),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-menu",
                                                      attrs: {
                                                        "aria-labelledby":
                                                          "dropdownMenuButtonEditExpenseDiscount"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item p-1 small",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.editExpenseDiscount(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Edit"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item p-1 small",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.removeDiscount(
                                                                index,
                                                                expense.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Delete"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                  ],
                                  2
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.$_can("jobs.discount.add.carrier.covered") ||
                            _vm.$_can("jobs.discount.add.office.covered") ||
                            _vm.$_can("jobs.discount.add.general.covered")) &&
                          _vm.addingNewDiscountExpense === true
                            ? _c(
                                "div",
                                { staticClass: "row mt-3 pt-3 border-top" },
                                [
                                  _c("div", { staticClass: "col-5 pr-1" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border rounded amount-wrap-small"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.newDiscount.name,
                                              expression: "newDiscount.name"
                                            }
                                          ],
                                          staticClass: "form-control p-1",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Discount name"
                                          },
                                          domProps: {
                                            value: _vm.newDiscount.name
                                          },
                                          on: {
                                            keydown: function($event) {
                                              _vm.clearError($event)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.newDiscount,
                                                "name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn input-group-btn edit-transaction-remove",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.addingNewDiscountExpense = false
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-remove"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-3 pr-1" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "border rounded" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.newDiscount.amount,
                                                expression: "newDiscount.amount"
                                              }
                                            ],
                                            staticClass: "form-control pl-1",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Amount"
                                            },
                                            domProps: {
                                              value: _vm.newDiscount.amount
                                            },
                                            on: {
                                              keydown: function($event) {
                                                _vm.clearError($event)
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.newDiscount,
                                                  "amount",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("error-field", {
                                        attrs: {
                                          errors: _vm.errors,
                                          field: "amount"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-4" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "border rounded amount-wrap-small pr-2"
                                        },
                                        [
                                          _c("simple-select", {
                                            staticClass:
                                              "form-control p-1 small-simple-select",
                                            attrs: {
                                              "hide-deselect": true,
                                              options: _vm.discountUnitTypes,
                                              label: "name",
                                              placeholder: "Unit"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.errors.clear(
                                                  "discount_unit_type_id"
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.newDiscount
                                                  .discount_unit_type_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newDiscount,
                                                  "discount_unit_type_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "newDiscount.discount_unit_type_id"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("error-field", {
                                        attrs: {
                                          errors: _vm.errors,
                                          field: "discount_unit_type_id"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 d-flex justify-content-end pt-2"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-save",
                                          attrs: { type: "button" },
                                          on: { click: _vm.saveDiscount }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-save"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c("div", { staticClass: "row mt-2" }, [
                                _c("div", { staticClass: "col" }, [
                                  (_vm.$_can(
                                    "jobs.discount.add.carrier.covered"
                                  ) ||
                                    _vm.$_can(
                                      "jobs.discount.add.office.covered"
                                    ) ||
                                    _vm.$_can(
                                      "jobs.discount.add.general.covered"
                                    )) &&
                                  _vm.canEditJob
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "add-button pointer pull-right",
                                          class: {
                                            disabled:
                                              !_vm.userHasAccessToCarrier ||
                                              _vm.isFlatRate
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled:
                                              !_vm.userHasAccessToCarrier ||
                                              _vm.isFlatRate
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addingNewExpense("discount")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Add discount\n                "
                                          ),
                                          _vm._m(11)
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(12),
                    _vm._v(" "),
                    _vm.job && _vm.job.charges
                      ? _vm._l(
                          _vm.job.charges.filter(function(el) {
                            return el.payment_type_id === 3
                          }),
                          function(transaction, index) {
                            return _c(
                              "div",
                              {
                                key: "trans-prefix-3-" + index,
                                staticClass: "row"
                              },
                              [
                                _c("div", { staticClass: "col-7" }, [
                                  _c("h5", { staticClass: "d-inline" }, [
                                    _vm._v(
                                      _vm._s(transaction.payment_type.name)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup m-0",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.$set(
                                            _vm.showTooltipTransactions,
                                            index,
                                            true
                                          )
                                        },
                                        mouseout: function($event) {
                                          _vm.$set(
                                            _vm.showTooltipTransactions,
                                            index,
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipTransactions[index]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover popover-transaction tippy-info-popover"
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(_vm._s(transaction.date))
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  transaction.payment_method
                                                    .name
                                                ) +
                                                "\n                  " +
                                                _vm._s(
                                                  transaction.payment_method_id ===
                                                    4 &&
                                                    "(**** " +
                                                      transaction.card.last4 +
                                                      ")"
                                                ) +
                                                "\n                "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(transaction.note))
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-5 text-right" }, [
                                  _vm._v("$ " + _vm._s(transaction.amount))
                                ])
                              ]
                            )
                          }
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-4 mb-2" }, [
                      _c("div", { staticClass: "col-7" }, [
                        _c(
                          "h4",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.paymentsTogglePayments = !_vm.paymentsTogglePayments
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa text-secondary",
                              class: _vm.paymentsTogglePayments
                                ? "fa fa-caret-down"
                                : "fa fa-caret-right",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c("strong", { staticClass: "pl-1" }, [
                              _vm._v(
                                "\n                Payments\n              "
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-5 text-right" }, [
                        _c("strong", [
                          _vm._v(
                            "$ " +
                              _vm._s(_vm.paymentsSum ? _vm.paymentsSum : "0")
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.paymentsTogglePayments
                      ? [
                          _vm.job.charges
                            ? _vm._l(
                                _vm.job.charges.filter(function(el) {
                                  return el.payment_type_id === 1
                                }),
                                function(transaction, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "trans-prefix-1-" + index,
                                      staticClass: "row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 billing-payment-name"
                                        },
                                        [
                                          _c(
                                            "h5",
                                            { staticClass: "d-inline" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  transaction.payment_method
                                                    .name
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-link p-0 tippy-popup m-0",
                                              on: {
                                                mouseover: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipPayments,
                                                    index,
                                                    true
                                                  )
                                                },
                                                mouseout: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipPayments,
                                                    index,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-info-circle"
                                              }),
                                              _vm._v(" "),
                                              _vm.showTooltipPayments[index]
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "popover popover-transaction tippy-info-popover"
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            transaction.date
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              transaction.payment_method_id ===
                                                              4
                                                                ? "(**** " +
                                                                  transaction
                                                                    .card
                                                                    .last4 +
                                                                  ")"
                                                                : ""
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            transaction.note
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-5 text-right" },
                                        [
                                          _vm._v(
                                            "$ " + _vm._s(transaction.amount)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.refundsSum !== null
                      ? _c("div", { staticClass: "row mt-4 mb-2" }, [
                          _c("div", { staticClass: "col-7" }, [
                            _c(
                              "h4",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function($event) {
                                    _vm.paymentsToggleRefunds = !_vm.paymentsToggleRefunds
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa text-secondary",
                                  class: _vm.paymentsToggleRefunds
                                    ? "fa fa-caret-down"
                                    : "fa fa-caret-right",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("strong", { staticClass: "pl-1" }, [
                                  _vm._v(
                                    "\n                Refunds\n              "
                                  )
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-5 text-right" }, [
                            _c("strong", [
                              _vm._v(
                                "$ " +
                                  _vm._s(
                                    _vm.refundsSum !== null
                                      ? _vm.refundsSum
                                      : "0"
                                  )
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paymentsToggleRefunds
                      ? [
                          _vm.job.charges
                            ? _vm._l(
                                _vm.job.charges.filter(function(el) {
                                  return (
                                    el.payment_type_id === 2 ||
                                    el.payment_type_id === 4
                                  )
                                }),
                                function(transaction, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "trans-prefix-2-" + index,
                                      staticClass: "row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 billing-payment-name"
                                        },
                                        [
                                          _c(
                                            "h5",
                                            { staticClass: "d-inline" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  transaction.payment_method
                                                    .name
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-link p-0 tippy-popup m-0",
                                              on: {
                                                mouseover: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipRefunds,
                                                    index,
                                                    true
                                                  )
                                                },
                                                mouseout: function($event) {
                                                  _vm.$set(
                                                    _vm.showTooltipRefunds,
                                                    index,
                                                    false
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-info-circle"
                                              }),
                                              _vm._v(" "),
                                              _vm.showTooltipRefunds[index]
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "popover popover-transaction tippy-info-popover"
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            transaction
                                                              .payment_type.name
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            transaction.date
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              transaction.payment_method_id ===
                                                              4
                                                                ? "(**** " +
                                                                  transaction
                                                                    .card
                                                                    .last4 +
                                                                  ")"
                                                                : ""
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            transaction.note
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-5 text-right" },
                                        [
                                          _vm._v(
                                            "$ " + _vm._s(transaction.amount)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "col" }, [
                        _vm.$_can("job-expenses.store")
                          ? _c(
                              "button",
                              {
                                staticClass: "add-button pointer pull-right",
                                class: {
                                  disabled:
                                    !_vm.userHasAccessToCarrier ||
                                    _vm.isFlatRate
                                },
                                attrs: {
                                  type: "button",
                                  disabled:
                                    !_vm.userHasAccessToCarrier ||
                                    _vm.isFlatRate
                                },
                                on: { click: _vm.toggleTransactionsModal }
                              },
                              [
                                _vm._v(
                                  "\n              Add Transaction\n              "
                                ),
                                _vm._m(13)
                              ]
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.job.cash_collected === false && _vm.canShowCashCollect
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex align-items-center justify-content-center w-full mt-3"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "btn-status btn-inprogress" },
                              [
                                _vm._v(
                                  "\n            Cash not collected\n          "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job.total_hours
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row mt-5 pt-3 border-top total-price"
                            },
                            [
                              _vm._m(14),
                              _vm._v(" "),
                              !_vm.isFlatRate
                                ? _c(
                                    "div",
                                    { staticClass: "col-7 text-right pl-0" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "$ " + _vm._s(_vm.job.total_price)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.job.cash_discount_applied === 1 &&
                                      _vm.job.remaining_cash_price === "-"
                                        ? _c(
                                            "p",
                                            { staticClass: "cash-discount" },
                                            [
                                              _vm._v(
                                                "\n                Paid fully in cash\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "col-7 text-right pl-0" },
                                    [
                                      _c("p", [
                                        _vm._v("$ " + _vm._s(_vm.job.price))
                                      ])
                                    ]
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row total-fee disabled" }, [
                            _vm._m(15),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-5 text-right" }, [
                              _c("p", [
                                _vm._v("$ " + _vm._s(_vm.job.total_fee))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row balance-due" }, [
                            _vm._m(16),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-6 text-right text-danger" },
                              [
                                _c("p", [
                                  _vm._v("$ " + _vm._s(_vm.job.remaining_price))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.isFlatRate
                            ? [
                                _vm.job.cash_discount_applied === 0 &&
                                _vm.job.remaining_cash_price !== "-"
                                  ? _c(
                                      "div",
                                      { staticClass: "row balance-due" },
                                      [
                                        _c("div", { staticClass: "col" }, [
                                          _vm.job.company.cash_discount_value >
                                          0
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "cash-discount text-danger"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  with cash discount $ " +
                                                      _vm._s(
                                                        _vm.job
                                                          .remaining_cash_price
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job.status
                      ? [
                          _vm.$_can("jobs.status.update") && _vm.isActive
                            ? _c("div", { staticClass: "row mt-4" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _vm.showTooltipCompleteJob
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "popover tippy-info-up"
                                        },
                                        [
                                          _vm._v(
                                            "\n                Total time for the job must be entered\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-12 text-right",
                                    on: {
                                      mouseover: function($event) {
                                        !_vm.job.total_hours &&
                                          (_vm.showTooltipCompleteJob = true)
                                      },
                                      mouseout: function($event) {
                                        !_vm.job.total_hours &&
                                          (_vm.showTooltipCompleteJob = false)
                                      }
                                    }
                                  },
                                  [
                                    _vm.job.status.id === 40
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary w-100",
                                            attrs: {
                                              type: "button",
                                              disabled: !_vm.userHasAccessToCarrier
                                            },
                                            on: { click: _vm.stopTimeTracking }
                                          },
                                          [
                                            _vm._v(
                                              "\n                Stop time tracking\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showCompleteButton
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary w-100",
                                            class: {
                                              disabled:
                                                !_vm.canComplete ||
                                                !_vm.userHasAccessToCarrier
                                            },
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.canComplete ||
                                                !_vm.userHasAccessToCarrier
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.showAreYouSureModal = !_vm.showAreYouSureModal
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                Complete Job\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.job.status.name === "Completed"
                            ? _c("div", { staticClass: "row mt-4" }, [
                                _c("div", { staticClass: "col-9 text-right" }, [
                                  _vm.job.ratings &&
                                  _vm.job.ratings.length &&
                                  _vm.job.source.name !== "Mod24"
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-success w-100",
                                          attrs: {
                                            type: "button",
                                            disabled: "disabled"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Review received\n              "
                                          )
                                        ]
                                      )
                                    : _vm.$_can("jobs.review.request") &&
                                      !_vm.job.review_requested
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary w-100",
                                            class: {
                                              disabled: !_vm.userHasAccessToCarrier
                                            },
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                _vm.reviewRequested ||
                                                !_vm.userHasAccessToCarrier
                                            },
                                            on: {
                                              click: function() {
                                                return _vm.requestReview()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                Request review\n              "
                                            )
                                          ]
                                        )
                                      : _vm.$_can(
                                          "jobs.resend.review.request"
                                        ) && _vm.job.review_requested
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary w-100",
                                              class: {
                                                disabled: !_vm.userHasAccessToCarrier
                                              },
                                              attrs: {
                                                type: "button",
                                                disabled:
                                                  _vm.reviewRequested ||
                                                  !_vm.userHasAccessToCarrier
                                              },
                                              on: {
                                                click: function() {
                                                  return _vm.requestReview(true)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                Resend review request\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                ])
                              ])
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCustomerModal
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showCustomerModal = false
                  }
                }
              },
              [
                _vm.showCustomerModal
                  ? _c("side-modal-customer-info", {
                      attrs: {
                        data: _vm.job,
                        "show-customer-modal": _vm.showCustomerModal,
                        "job-id": _vm.job.id
                      },
                      on: {
                        "show-customer-modal-toggle": function($event) {
                          _vm.showCustomerModal = !_vm.showCustomerModal
                        },
                        update: _vm.getJob,
                        cancel: function($event) {
                          _vm.showCustomerModal = false
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.companyReviewModal
        ? _c("CustomerReviewModal", {
            attrs: { job: _vm.job },
            on: {
              getJob: _vm.getJob,
              close: function($event) {
                _vm.companyReviewModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalAssignMovers
        ? _c(
            "modal",
            {
              attrs: { "loading-button": _vm.loadingButton },
              on: {
                close: function($event) {
                  _vm.showModalAssignMovers = false
                },
                ok: _vm.assignMovers
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Assign movers")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col" }, [
                      !_vm.job.carrier_id
                        ? _c("p", { staticClass: "text-danger" }, [
                            _vm._v(
                              "Please assign carrier to view available movers"
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        { staticClass: "select-wrap" },
                        [
                          _c("label", [_vm._v("Foreman")]),
                          _vm._v(" "),
                          _vm.movers
                            ? _c("simple-select", {
                                attrs: {
                                  "hide-deselect": true,
                                  options: _vm.foremenOptions.filter(function(
                                    mover
                                  ) {
                                    return !_vm.assign.movers.includes(mover)
                                  }),
                                  label: "first_name",
                                  "custom-label": _vm.customLabel,
                                  placeholder: "Select"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.errors.clear("mover_availability")
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "option",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "option__desc" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center justify-content-between"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "option__title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          props.option
                                                            .first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          props.option.last_name
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                    props.option.unavailable
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "- unavailable"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                props.option.ref_id &&
                                                props.option.job_id
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "option__small m-0-auto pr-5 font-weight-bold position-absolute",
                                                        staticStyle: {
                                                          color: "#ffab00",
                                                          position: "absolute",
                                                          right: "30%"
                                                        },
                                                        on: {
                                                          mousedown: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              !(
                                                                "button" in
                                                                $event
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "left",
                                                                37,
                                                                $event.key,
                                                                [
                                                                  "Left",
                                                                  "ArrowLeft"
                                                                ]
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            if (
                                                              "button" in
                                                                $event &&
                                                              $event.button !==
                                                                0
                                                            ) {
                                                              return null
                                                            }
                                                            $event.stopPropagation()
                                                            _vm.navigateToJob(
                                                              props.option
                                                                .job_id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Assigned to " +
                                                            _vm._s(
                                                              props.option
                                                                .ref_id
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.assign.foreman,
                                  callback: function($$v) {
                                    _vm.$set(_vm.assign, "foreman", $$v)
                                  },
                                  expression: "assign.foreman"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        { staticClass: "select-wrap" },
                        [
                          _c("label", [_vm._v("Movers")]),
                          _vm._v(" "),
                          _vm.movers
                            ? _c("multiselect", {
                                attrs: {
                                  options: _vm.movers.filter(function(mover) {
                                    return mover.id !== _vm.assign.foreman
                                  }),
                                  multiple: true,
                                  "clear-on-select": false,
                                  "hide-selected": true,
                                  "preserve-search": false,
                                  "select-label": _vm.customSelectLabel,
                                  "custom-label": _vm.customLabel,
                                  "track-by": "id"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.errors.clear("mover_availability")
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "tag",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "multiselect__tag" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  props.option.first_name &&
                                                    props.option.first_name
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  props.option.last_name &&
                                                    props.option.last_name
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            props.option.unavailable
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v("- unavailable")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "multiselect__tag-icon",
                                              on: {
                                                click: function($event) {
                                                  props.remove(props.option)
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "option",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "option__desc" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center justify-content-between"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "option__title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          props.option
                                                            .first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          props.option.last_name
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                    props.option.unavailable
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "- unavailable"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                props.option.ref_id &&
                                                props.option.job_id
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "option__small m-0-auto pr-5 font-weight-bold position-absolute",
                                                        staticStyle: {
                                                          color: "#ffab00",
                                                          position: "absolute",
                                                          right: "30%"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              !(
                                                                "button" in
                                                                $event
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "left",
                                                                37,
                                                                $event.key,
                                                                [
                                                                  "Left",
                                                                  "ArrowLeft"
                                                                ]
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            if (
                                                              "button" in
                                                                $event &&
                                                              $event.button !==
                                                                0
                                                            ) {
                                                              return null
                                                            }
                                                            if (
                                                              $event.ctrlKey ||
                                                              $event.shiftKey ||
                                                              $event.altKey ||
                                                              $event.metaKey
                                                            ) {
                                                              return null
                                                            }
                                                            $event.stopPropagation()
                                                            _vm.navigateToJob(
                                                              props.option
                                                                .job_id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Assigned to " +
                                                            _vm._s(
                                                              props.option
                                                                .ref_id
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.assign.movers,
                                  callback: function($$v) {
                                    _vm.$set(_vm.assign, "movers", $$v)
                                  },
                                  expression: "assign.movers"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "mover_availability" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalAssignTrucks
        ? _c(
            "modal",
            {
              attrs: { "loading-button": _vm.loadingButton },
              on: {
                close: function($event) {
                  _vm.showModalAssignTrucks = false
                },
                ok: _vm.assignTrucks
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Assign trucks")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  !_vm.job.carrier_id
                    ? _c("p", { staticClass: "text-danger" }, [
                        _vm._v("Please assign carrier to view available trucks")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Trucks")]),
                      _vm._v(" "),
                      _c("multiselect", {
                        attrs: {
                          options: _vm.trucks,
                          multiple: true,
                          "clear-on-select": false,
                          "hide-selected": true,
                          "preserve-search": false,
                          label: "name",
                          "track-by": "id",
                          "select-label": _vm.customSelectLabel,
                          taggable: true
                        },
                        on: {
                          input: function($event) {
                            _vm.errors.clear("truck_availability")
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "tag",
                            fn: function(props) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "multiselect__tag" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(props.option.name) + " ")
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "multiselect__tag-icon",
                                      on: {
                                        click: function($event) {
                                          props.remove(props.option)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "option",
                            fn: function(props) {
                              return [
                                _c("div", { staticClass: "option__desc" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "option__title" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(props.option.name) +
                                              "\n                  "
                                          ),
                                          props.option.unavailable
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v("- unavailable")]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      props.option.ref_id && props.option.job_id
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "option__small m-0-auto pr-5 font-weight-bold",
                                              staticStyle: { color: "#ffab00" },
                                              on: {
                                                click: function($event) {
                                                  if (
                                                    !("button" in $event) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "left",
                                                      37,
                                                      $event.key,
                                                      ["Left", "ArrowLeft"]
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  if (
                                                    "button" in $event &&
                                                    $event.button !== 0
                                                  ) {
                                                    return null
                                                  }
                                                  if (
                                                    $event.ctrlKey ||
                                                    $event.shiftKey ||
                                                    $event.altKey ||
                                                    $event.metaKey
                                                  ) {
                                                    return null
                                                  }
                                                  $event.stopPropagation()
                                                  _vm.navigateToJob(
                                                    props.option.job_id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Assigned to " +
                                                  _vm._s(props.option.ref_id) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.assign.trucks,
                          callback: function($$v) {
                            _vm.$set(_vm.assign, "trucks", $$v)
                          },
                          expression: "assign.trucks"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "truck_availability" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCarrierReassignModal
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large", "close-strict": true },
              on: {
                close: function($event) {
                  _vm.showCarrierReassignModal = false
                  _vm.job.carrier_id = _vm.job.carrier
                    ? _vm.job.carrier.id
                    : null
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Assign carrier")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _vm.job.carrier
                    ? _c("p", [
                        _vm._v(
                          "\n        Changing assigned carrier will remove all movers and trucks from this move.\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column" },
                    [
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", {
                          staticClass:
                            "col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "row col-md-8" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-3 d-flex align-items-center justify-content-center"
                            },
                            [
                              _c("small", { staticClass: "text-secondary" }, [
                                _vm._v("Movers AM")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-3 d-flex align-items-center justify-content-center"
                            },
                            [
                              _c("small", { staticClass: "text-secondary" }, [
                                _vm._v("Movers PM")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-3 d-flex align-items-center justify-content-center"
                            },
                            [
                              _c("small", { staticClass: "text-secondary" }, [
                                _vm._v("Trucks AM")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-3 d-flex align-items-center justify-content-center"
                            },
                            [
                              _c("small", { staticClass: "text-secondary" }, [
                                _vm._v("Trucks PM")
                              ])
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.carriersForAssign, function(carrier) {
                        return _c(
                          "div",
                          {
                            key: carrier.name,
                            staticClass: "form-row",
                            class: {
                              "radio-border-blue":
                                _vm.job.carrier_id === carrier.id
                            },
                            on: {
                              click: function($event) {
                                _vm.setCarrier(carrier.id)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-4 text-right pt-2 pl-0 cc-n-umber radio-button-wrap ml-3"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "pointer text-left w-100 h-100 d-flex align-items-center"
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "radio",
                                        id: "carrier-" + carrier.id
                                      },
                                      domProps: {
                                        checked:
                                          _vm.job.carrier_id === carrier.id
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "btn-radio" }),
                                    _vm._v(" "),
                                    _c("label", {
                                      staticClass: "btn-radio-label",
                                      attrs: { for: "carrier-" + carrier.id },
                                      domProps: {
                                        textContent: _vm._s(carrier.name)
                                      }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row col-md-8" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 d-flex align-items-center justify-content-center"
                                },
                                [
                                  _c("span", {
                                    staticClass: "btn-status btn-amount",
                                    class: [
                                      _vm.giveStyleAssignCarrierAvailability(
                                        carrier,
                                        "movers",
                                        "am"
                                      )
                                    ],
                                    domProps: {
                                      textContent: _vm._s(
                                        carrier.available_movers_am +
                                          " / " +
                                          carrier.total_movers
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 d-flex align-items-center justify-content-center"
                                },
                                [
                                  _c("span", {
                                    staticClass: "btn-status btn-amount",
                                    class: [
                                      _vm.giveStyleAssignCarrierAvailability(
                                        carrier,
                                        "movers",
                                        "pm"
                                      )
                                    ],
                                    domProps: {
                                      textContent: _vm._s(
                                        carrier.available_movers_pm +
                                          " / " +
                                          carrier.total_movers
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 d-flex align-items-center justify-content-center"
                                },
                                [
                                  _c("span", {
                                    staticClass: "btn-status btn-amount",
                                    class: [
                                      _vm.giveStyleAssignCarrierAvailability(
                                        carrier,
                                        "trucks",
                                        "am"
                                      )
                                    ],
                                    domProps: {
                                      textContent: _vm._s(
                                        carrier.available_trucks_am +
                                          " / " +
                                          carrier.total_trucks
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 d-flex align-items-center justify-content-center"
                                },
                                [
                                  _c("span", {
                                    staticClass: "btn-status btn-amount",
                                    class: [
                                      _vm.giveStyleAssignCarrierAvailability(
                                        carrier,
                                        "movers",
                                        "pm"
                                      )
                                    ],
                                    domProps: {
                                      textContent: _vm._s(
                                        carrier.available_trucks_pm +
                                          " / " +
                                          carrier.total_trucks
                                      )
                                    }
                                  })
                                ]
                              )
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "availability" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.showCarrierReassignModal = false
                            _vm.job.carrier_id = _vm.job.carrier
                              ? _vm.job.carrier.id
                              : null
                          }
                        }
                      },
                      [_vm._v("\n            Discard\n          ")]
                    ),
                    _vm._v(" "),
                    _c("button", {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      domProps: {
                        textContent: _vm._s(
                          _vm.job.carrier ? "Reassign" : "Assign"
                        )
                      },
                      on: { click: _vm.reassignCarrier }
                    })
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showUserReassignModal
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large", "close-strict": true },
              on: {
                close: function($event) {
                  _vm.showUserReassignModal = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", [
                      _c("h4", [_vm._v("Select user to assign job to")])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Select User")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: { options: _vm.assignees },
                        on: {
                          change: function($event) {
                            _vm.clearError($event)
                          }
                        },
                        model: {
                          value: _vm.assigneeId,
                          callback: function($$v) {
                            _vm.assigneeId = $$v
                          },
                          expression: "assigneeId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "cluster_user_id" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary pull-right",
                        attrs: { type: "button" },
                        on: { click: _vm.reassignUser }
                      },
                      [_vm._v("\n            Reassign\n          ")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.newTransaction
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _c("transactions-modal", {
                  staticClass: "sidebar-right",
                  attrs: { job: _vm.job },
                  on: {
                    cancel: _vm.toggleTransactionsModal,
                    update: _vm.sendMovingContractEmail
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showModalCancelJob
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.showModalCancelJob = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Cancellation note")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap h-auto" }, [
                        _c("label", [_vm._v("Note")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.note,
                              expression: "note"
                            }
                          ],
                          staticClass: "select-wrap-textarea form-control",
                          attrs: { rows: "5" },
                          domProps: { value: _vm.note },
                          on: {
                            keydown: function($event) {
                              _vm.clearError($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.note = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "note" }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.showModalCancelJob = false
                          }
                        }
                      },
                      [_vm._v("\n            Discard\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function($event) {
                            _vm.changeStatus(_vm.job.id, 30)
                          }
                        }
                      },
                      [_vm._v("Proceed")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalRejectJob
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.showModalRejectJob = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", { staticClass: "pb-2" }, [_vm._v("Rejection note")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("p", { staticClass: "mb-1" }, [
                      _vm._v("\n            Move "),
                      _c("b", [_vm._v(_vm._s(_vm.job.ref_id))]),
                      _vm._v(" was marked as "),
                      _vm.job.is_small === 1
                        ? _c("span", [_vm._v("a")])
                        : _c("span", [_vm._v("an")]),
                      _vm._v(" " + _vm._s(_vm.isSmallJob) + ",\n            "),
                      _vm.job.is_small === 1
                        ? _c("span", [
                            _vm._v("deselect it for an all day job.")
                          ])
                        : _c("span", [_vm._v("select it for a small job.")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "customer-check-field pb-3" }, [
                      _c("span", { staticClass: "customer-checkmark" }),
                      _vm._v("\n            Small job\n            "),
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: _vm.job.is_small,
                          checked: _vm.job.is_small === 1
                        },
                        on: { change: _vm.changeSmallJob }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-wrap h-auto mt-3" }, [
                      _c("label", [_vm._v("Note")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.note,
                            expression: "note"
                          }
                        ],
                        staticClass: "select-wrap-textarea form-control",
                        attrs: { rows: "5" },
                        domProps: { value: _vm.note },
                        on: {
                          keydown: function($event) {
                            _vm.clearError($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.note = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.showModalRejectJob = false
                          }
                        }
                      },
                      [_vm._v("\n            Discard\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function($event) {
                            _vm.updateJobStatusChange(_vm.job.id, 31)
                          }
                        }
                      },
                      [_vm._v("\n            Proceed\n          ")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalAcceptJob
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.showModalAcceptJob = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", { staticClass: "pb-2" }, [_vm._v("Accept job")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", [
                      _c("p", { staticClass: "mb-1" }, [
                        _vm._v("\n              Move "),
                        _c("b", [_vm._v(_vm._s(_vm.job.ref_id))]),
                        _vm._v(" was marked as "),
                        _vm.job.is_small === 1
                          ? _c("span", [_vm._v("a")])
                          : _c("span", [_vm._v("an")]),
                        _vm._v(
                          " " + _vm._s(_vm.isSmallJob) + ",\n              "
                        ),
                        _vm.job.is_small === 1
                          ? _c("span", [
                              _vm._v("deselect if it is a all day job.")
                            ])
                          : _c("span", [
                              _vm._v("select it if its a small job.")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "customer-check-field" }, [
                        _c("span", { staticClass: "customer-checkmark" }),
                        _vm._v("\n              Small job\n              "),
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: _vm.job.is_small,
                            checked: _vm.job.is_small === 1
                          },
                          on: { change: _vm.changeSmallJob }
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.showModalAcceptJob = false
                          }
                        }
                      },
                      [_vm._v("\n            Discard\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function($event) {
                            _vm.updateJobStatusChange(_vm.job.id, 3)
                          }
                        }
                      },
                      [_vm._v("\n            Accept\n          ")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalIsSmallJob
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.showModalIsSmallJob = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", { staticClass: "pb-2" }, [_vm._v("Job size")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", [
                      _c("p", { staticClass: "mb-1" }, [
                        _vm._v("\n              Move "),
                        _c("b", [_vm._v(_vm._s(_vm.job.ref_id))]),
                        _vm._v(" was marked as "),
                        _vm.job.is_small === 1
                          ? _c("span", [_vm._v("a")])
                          : _c("span", [_vm._v("an")]),
                        _vm._v(
                          " " + _vm._s(_vm.isSmallJob) + ",\n              "
                        ),
                        _vm.job.is_small === 1
                          ? _c("span", [
                              _vm._v("deselect if it is a all day job.")
                            ])
                          : _c("span", [
                              _vm._v("select it if its a small job.")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "customer-check-field" }, [
                        _c("span", { staticClass: "customer-checkmark" }),
                        _vm._v("\n              Small job\n              "),
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: _vm.job.is_small,
                            checked: _vm.job.is_small === 1
                          },
                          on: { change: _vm.changeSmallJob }
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.save }
                      },
                      [_vm._v("Save")]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sendAutomaticMessages === true
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.sendAutomaticMessages = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Send Automatic Messages")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", [
                      _vm._v(
                        "\n            You are about to send automatically generated messages to movers."
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            Are you sure you want to continue?\n          "
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6 pr-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary w-100",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.sendAutomaticMessages = false
                          }
                        }
                      },
                      [_vm._v("\n            Cancel\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 pl-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary w-100 ld-ext-right",
                        class: { running: _vm.loadingButton },
                        attrs: {
                          type: "button",
                          disabled: _vm.buttonDisabled || _vm.loadingButton
                        },
                        on: { click: _vm.sendMessages }
                      },
                      [
                        _vm._v("\n            Continue\n            "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newClaim
        ? _c("CreateClaimModal", {
            attrs: { job: _vm.job },
            on: {
              closeModal: function($event) {
                _vm.newClaim = false
              },
              update: _vm.getJob
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAreYouSureModal
        ? _c("AreYouSure", {
            on: {
              prevStep: _vm.prevStep,
              getJob: _vm.getJob,
              close: function($event) {
                _vm.showAreYouSureModal = false
              },
              errors: _vm.recordErrors
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAreYouSureRevertModal
        ? _c("AreYouSureRevertToAccepted", {
            attrs: { loading: _vm.areYouSureLoading },
            on: {
              revertToAccepted: _vm.revertToAccepted,
              close: function($event) {
                _vm.showAreYouSureRevertModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAreYouSureRevertTotalTimeModal
        ? _c("AreYouSureRevertToTotalTime", {
            attrs: { loading: _vm.areYouSureTotalTimeLoading },
            on: {
              revertToTotalTime: _vm.revertToTotalTime,
              close: function($event) {
                _vm.showAreYouSureRevertTotalTimeModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSendEpayLinkModal
        ? _c("SendEpayLink", {
            attrs: { job: _vm.job },
            on: {
              close: function($event) {
                _vm.showSendEpayLinkModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showClearCashDiscountModal
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.showClearCashDiscountModal = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c(
                  "h4",
                  {
                    staticClass:
                      "text-black-50 d-flex align-items-center justify-content-start"
                  },
                  [_vm._v("\n        Remove Cash discount\n      ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("p", { staticClass: "text-center" }, [
                  _vm._v("Are you sure to remove Cash Discount?")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-center",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.removeCashDiscount()
                        }
                      }
                    },
                    [_vm._v("Yes")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.showClearCashDiscountModal = false
                        }
                      }
                    },
                    [_vm._v("\n        No\n      ")]
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-danger text-right" }, [
      _c("small", [_c("strong", [_vm._v("JOB CANCELLED")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-7 p-3 bg-grey" }, [
      _c("h4", [_c("strong", [_vm._v("Total job time")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-7" }, [
      _c("h5", { staticClass: "d-inline" }, [_vm._v("Total duration")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-7" }, [
      _c("h5", { staticClass: "d-inline" }, [_vm._v("DDT")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-7" }, [
      _c("h5", { staticClass: "d-inline" }, [_vm._v("Total breaks")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4 mb-2" }, [
      _c("div", { staticClass: "col-12 p-3 bg-grey" }, [
        _c("h4", [_c("strong", [_vm._v("Price breakdown")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        attrs: {
          id: "dropdownMenuButtonEditExpenseAddition",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("i", {
          staticClass: "fa fa-ellipsis-h text-secondary",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-2 mr-0" }, [
      _c("span", { staticClass: "mod-icon-add" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-2 mr-0" }, [
      _c("span", { staticClass: "mod-icon-add" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        attrs: {
          id: "dropdownMenuButtonEditExpenseDiscount1",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("i", {
          staticClass: "fa fa-ellipsis-h text-secondary",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        attrs: {
          id: "dropdownMenuButtonEditExpenseDiscount",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("i", {
          staticClass: "fa fa-ellipsis-h text-secondary",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-2 mr-0" }, [
      _c("span", { staticClass: "mod-icon-add" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4 mb-2" }, [
      _c("div", { staticClass: "col-12 p-3 bg-grey" }, [
        _c("h4", [_c("strong", [_vm._v("Transactions")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-2 mr-0" }, [
      _c("span", { staticClass: "mod-icon-add" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("Total price")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-7" }, [
      _c("h5", [_vm._v("Total fee")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h5", [_vm._v("Balance due")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4900e64e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4900e64e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobsEdit.vue
// module id = null
// module chunks = 